/*
  These functions are used in multiple fs-*.js files, so it is loaded in the header in theme.liquid before fs-hooks is rendered.
  the default filter variables are defined here as well and used throughout the files
*/
const fsInStockOnlineFilterTagPartial = 'Availability_In Stock Online ';
const fsAvailabilityFilterCheckboxTextInStockOnlineAtStore = 'In Stock Online';


  const fsInStockFilterTitle = 'Availability';
  const fsInStockFilterTagPartial = 'Availability_Same Day Pickup ';
  const fsAvailabilityFilterCheckboxTextPartialEligibleAt = 'Same Day Pickup '; 
  const fsAvailabilityFilterId = '#fs_filter_availability';
  const fsSameDayPickupFilterTitle = fsInStockFilterTitle;
  const fsAvailabilityFilterCheckboxTextPartialInStockAt = 'Same Day Pickup';


const fsInStockCanadaWideTag = '__product_in_stock_canada';
const fsOnSaleFilterTitle = 'Sale';
const fsOnSaleFilterTag = 'Current Offering_On Sale';

const fsSameDayPickupFilterTagPartial = '__product_in_stock_';
const fsSameDayPickupFilterId = 'Isp-tag-SameDayPickup';


const fsClearanceFilterCheckboxTextPartial = 'Available at ';

const fsRemovableTagTextOnSale = 'On Sale';

const fsCustomElementClass = 'coast-custom-element';

let hasInStockCanadaWide = false; /* this variable is used in checkIsFilterOn() to see if we should check for in stock canada wide, it is set in fs-filters/loadAvailabilityFilter() */
let isOnlyInStockCanadaWide = false; /* this variable is used in checkIsFilterOn() to see if we should check for in stock canada wide, it is set in fs-filters/loadAvailabilityFilter() */


function getFiltersQueryString() {
  const url = new URL(window.location.href);
  return url.searchParams.get('filters'); /* the string that returns has whitespace in place of + */
}

function removeFilterFromQueryString(filterTitle, filterQueryString) {
  let queryFiltersString = getFiltersQueryString();
  const filterTagStringEnd = !!queryFiltersString.match(filterQueryString + ',') ? ',' : '';
  const isFilterTagInQueryFilters = !!queryFiltersString.match(filterQueryString);
  
  if(isFilterTagInQueryFilters) {
    const filterTagQueryString = `${filterQueryString}${filterTagStringEnd}`;
    queryFiltersString = queryFiltersString.replaceAll(filterTagQueryString, '');
  }
  
  if(filterTitle === fsInStockFilterTitle) { /* this action is caused by the in stock toggle so we need to remove inStockCanadaWide if it exists*/
    const inStockCanadaWideFilterQueryString = `${fsInStockFilterTitle},${fsInStockCanadaWideTag}`;
    queryFiltersString = queryFiltersString.replaceAll(inStockCanadaWideFilterQueryString, '');
  }

  if(queryFiltersString) {
    /* we need to remove the filterTagQueryString from the queryFiltersString and change the whitespace to + */
    queryFiltersString = queryFiltersString.replaceAll(' ', '+');
    /* also need to make sure the final char in the queryFiltersString is not a comma after we've changed it */
    const finalChar = queryFiltersString.charAt(queryFiltersString.length - 1);
    queryFiltersString = finalChar === ',' ? queryFiltersString.substring(0, queryFiltersString.length - 1) : queryFiltersString;
  }
  
  return queryFiltersString;
}

function addFilterToQueryString(filterValue) {
  const currentQueryFiltersString = getFiltersQueryString();
  const newQueryFiltersString = currentQueryFiltersString ? `${currentQueryFiltersString},${filterValue}` : filterValue;
  const finalNewQueryString = newQueryFiltersString.replaceAll(' ', '+');
  return finalNewQueryString;
}

function getFilterValue (filterTitle, filterTag, isWithFsInStockCanadaWideTag) {
  const url = new URL(window.location.href);
  let filtersString = url.searchParams.get('filters');

  const filterQueryString = `${filterTitle},${filterTag}`;
  
  const filterValuesArr = [filterTitle, filterTag];
  if(filterTitle === fsInStockFilterTitle && isWithFsInStockCanadaWideTag) { /* this action is caused by the in stock toggle so we need to add inStockCanadaWide if it exists*/
    filterValuesArr.push(filterTitle, fsInStockCanadaWideTag);
  }
  const filterValue = filterValuesArr.join(',');
  return filterValue;
}


function updateUrlFilters(filterTitle, filterTag) {
  const isFilterOn = checkIsFilterOn(filterTag);
  const filterValue = getFilterValue(filterTitle, filterTag, true);
  const newQueryFiltersString = isFilterOn ? removeFilterFromQueryString(filterTitle, filterQueryString) : addFilterToQueryString(filterValue);
  const url = new URL(window.location.href);
  const updatedUrl = buildFilterUrl(url, newQueryFiltersString);
  const updatedUrlObj = new URL(updatedUrl);
  updatedUrlObj.searchParams.set('autofilter', 'false');  /* add a new param autofilter with value false so setAutoFiltersMobile function code will not run  */
  const finalUpdatedUrl = updatedUrlObj.href;
  window.location.href = finalUpdatedUrl;
}

function checkIsFilterOn(filterTag) {
  const currentQueryFiltersString = getFiltersQueryString()?.toLowerCase();
  const lowerCaseFilterTag = filterTag.toLowerCase();
  let isFilterOn = currentQueryFiltersString ? currentQueryFiltersString.includes(lowerCaseFilterTag) : false;  /* if there are query filters, check if they have the filterTag that called this function */
  if(hasInStockCanadaWide && filterTag.includes(fsInStockFilterTagPartial) && isOnlyInStockCanadaWide === false) { 
   /* this block has no affect if not an in stock filter, e.g. when used for the sale filter */
    isFilterOn = currentQueryFiltersString?.includes(fsInStockFilterTagPartial) && currentQueryFiltersString?.includes(fsInStockCanadaWideTag);
  } else if (hasInStockCanadaWide && isOnlyInStockCanadaWide && filterTag.includes(fsInStockFilterTagPartial)) {
    isFilterOn = currentQueryFiltersString?.includes(fsInStockCanadaWideTag);
  }
  return isFilterOn;
}

function setToggleState(toggleInputElement, selectedFilterTag) {
  if(toggleInputElement) {
    setTimeout(() => {
      const isFilterOn = checkIsFilterOn(selectedFilterTag);
      toggleInputElement.checked = isFilterOn;
    }, 800);
  }
}

function buildFilterUrl(url, filtersString) { /* we use a placeholder because using url.searchParams.set() encodes the string and we need to keep ',' un-encoded for FS */
  const filterPlaceholder = 'FILTER_PLACEHOLDER';
  url.searchParams.set('filters', filterPlaceholder);
  let cleanFiltersString = filtersString.replaceAll(' ', '+');
  const finalChar = cleanFiltersString.charAt(cleanFiltersString.length - 1);
  cleanFiltersString = finalChar === ',' ? cleanFiltersString.substring(0, cleanFiltersString.length - 1) : cleanFiltersString;
  const updatedUrl = url.toString().replace(filterPlaceholder, cleanFiltersString);
  return updatedUrl;
}

const hideSameDayPickupRemovableTagsAndControlClearAllBtnVisibility = (removableTagsWrapper) => {
  const removableTags = removableTagsWrapper.querySelectorAll(".removable-tag");
  const removableTagsArray = Array.from(removableTags);
  const pattern = new RegExp(fsSameDayPickupFilterTagPartial + '\\d{3}');
  let removableTagsSameDayPickup = [];
  let removableTagsNonSameDayPickup = [];
  for (const removableTag of removableTags) {
    const removableTagText = removableTag.querySelector(".removable-tag-text").textContent.toLowerCase();
    if (pattern.test(removableTagText)) {
      removableTagsSameDayPickup.push(removableTag);
    } else {
      removableTagsNonSameDayPickup.push(removableTag);
    }
  }
  
  //individual removable tags for same day pickup are always hidden
  removableTagsSameDayPickup.forEach(removableTag => {
    removableTag.style.display = "none";
  });
  
  // show clear all btn when there is more than one non same day pick up removable tag showing
  const clearAllBtn = removableTagsWrapper.querySelector(".clear-all-button");
  
  if (removableTagsNonSameDayPickup.length > 1) {
    clearAllBtn.style.removeProperty('display');    
  } else if(clearAllBtn){ 
    clearAllBtn.style.setProperty('display', 'none', 'important');
  }    
}

//use store to primary mapping to get all fs same day pickup filter tags of the current selected store
const getfsSameDayPickupFilterTagsOfCurrentSelectedStore = () => {
  
    const storeName = GetSelectedStoreName();
    const inStockFilterTag = `${fsInStockFilterTagPartial}${storeName}`;
    const fsSameDayPickupFilterTags = [inStockFilterTag];
  

  return fsSameDayPickupFilterTags;
}

const handleShowOrHideSameDayPickupToggle = (facets) => {
  let allSameDayPickupCheckboxes = [];
  
    const storeName = GetSelectedStoreName();
    const inStockFilterTag = `${fsInStockFilterTagPartial}${storeName}`;
    const hasSameDayPickupFacet = facets.some(facet => facet.values.some(facetValue => facetValue.name === inStockFilterTag));
    if(hasSameDayPickupFacet) {
      allSameDayPickupCheckboxes.push(inStockFilterTag);
    }
  

  document.dispatchEvent(new CustomEvent("filters:hide-or-show-same-day-pickup-toggle", {
    detail: { allSameDayPickupCheckboxes: allSameDayPickupCheckboxes }
  }));
};

const getInStockFilterParamString = () => {
  
    const storeId = GetSelectedStoreId();
    const inStockFilterTag = `${fsInStockOnlineFilterTagPartial}${storeId}`;
  
  const inStockFilterParamString = getFilterValue(fsInStockFilterTitle, inStockFilterTag, false);
  return inStockFilterParamString;
}

const getInStockAtLocationFilterParamString = () => {
  const storeName = GetSelectedStoreName();
  const inStockFilterTag = `${fsInStockFilterTagPartial}${storeName}`;
  const inStockFilterParamString = getFilterValue(fsInStockFilterTitle, inStockFilterTag, false);
  return inStockFilterParamString;
}
